namespace GeniuzPOS.Inventory {
    export interface IcParaForm {
        IcFg: Serenity.RadioButtonEditor;
        PostSequenceFg: Serenity.EnumEditor;
    }

    export class IcParaForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcPara';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcParaForm.init)  {
                IcParaForm.init = true;

                var s = Serenity;
                var w0 = s.RadioButtonEditor;
                var w1 = s.EnumEditor;

                Q.initFormType(IcParaForm, [
                    'IcFg', w0,
                    'PostSequenceFg', w1
                ]);
            }
        }
    }
}
